define('views/modules/template/edit/calendar/calendar-component/template-calendar-day',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils', 'bootbox',
    // Services
    'services/i18n',
    // Views
    'views/modules/calendar/calendar/calendar-component/calendar-day',
    'views/parts/menu/menu-context',
    'views/modules/template/edit/calendar/calendar-component/template-calendar-item-sortable-list',
], function(
    // Libs
    _, Backbone, Mustache, moment, U, Bootbox,
    // Services
    i18n,
    // Views
    VCalendarDay,
    VMenuContext,
    VTemplateCalendarItemSortableList
) {

    var VTemplateCalendarDay = VCalendarDay.extend({

        initialize: function(options) {
            this.options = _.extend(this, {
                dayName: this.model.dayName
            }, options);

            var collection = this.collection = this.model.getItems();

            this.view = {
                list: new VTemplateCalendarItemSortableList({
                    collection: collection,
                    summary: false,
                })
            };
            this.listenTo(collection, {
                'day:click': this.onDayClick,
            });
        },

        render: function() {
            this.initListener();

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.options)));

            this.generateZones()
                .assign(this.view.list, this.zone.$list);

            return this;
        },

        toggleAddItemMenu: function(e) {
            // Prevent Click Anchor
            e.preventDefault();
            var view = this.view,
                menu = view.menu;
            if (!menu) {
                // defer the creation of the option menu view
                menu = view.menu = new VMenuContext({
                    context: this,
                    onClick: this.onActionClick,
                    collection: new Backbone.Collection([
                        { caption: 'Activity', icon: 'sl-icon-note', type: 'activity' },
                        { caption: 'Custom data', icon: 'sl-icon-user', type: 'custom_data' },
                        { caption: 'calendar:Animated session', icon: 'sl-icon-energy', type: 'animated' },
                        { caption: 'calendar:Nutrition', icon: 'sl-icon-cup', type: 'nutrilog' },
                    ]),
                });
                this.assign(menu, this.zone.$menu);
            }
            menu.toggle();
        },

        setActive: function(val) {
            this.$el.toggleClass("active", val);
        },

        ////////////
        // events //
        ////////////

        onDayClick: function(model) {
            this.setActive(true);
        },

        onActionClick: function(e, item) {
            this.model.trigger('add:day:item', this.model, item.get('type'));
            this.setActive(true);
        },

        onRoute: _.noop

    });

    return VTemplateCalendarDay;
});

